import React, { useCallback } from 'react';
import { trackV2 } from '@gumtree/shared/src/util/track-ga-event';
import { TabTitle } from '../styles';
import { changeCurrentTab, appendWidth } from '../desktop-motors-specs';

interface Props {
    dispatch: Function;
    label: string;
    index: number;
    currentTab: number;
    transformLeft?: number;
    clickHandler?: () => void;
}

const Tab: React.FC<Props> = ({ dispatch, index, currentTab, label, clickHandler, ...props }) => {
    const ref = useCallback((node) => {
        if (node) {
            dispatch(appendWidth(node.getBoundingClientRect().width, index));
        }
    }, []);

    return (
        <TabTitle
            ref={ref}
            activeTab={currentTab === index}
            data-q="motors-attributes-titles"
            onClick={() => {
                clickHandler && clickHandler();
                dispatch(changeCurrentTab(index));
                trackV2('MotorsSpecTab', `${index + 1}`);
            }}
            {...props}
        >
            {label === 'Additional Features' ? 'Features' : label}
        </TabTitle>
    );
};

export default Tab;
